import { render, staticRenderFns } from "./section-carousel.vue?vue&type=template&id=54cc4112&"
import script from "./section-carousel.vue?vue&type=script&lang=js&"
export * from "./section-carousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports